import { createFileRoute } from "@tanstack/react-router"

import { CleanupPanel } from "@/pages/CleanupPanel"

export const Route = createFileRoute("/operations/cleanup")({
  component: CleanupPanel,
})
